
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freshservice-integration",
      function () {
        return require("private-next-pages/freshservice-integration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freshservice-integration"])
      });
    }
  